module.exports = __webpack_public_path__ + "img/consultoria_9-16.48dbcd2d.jpg";